module.exports = __webpack_public_path__ + "static/media/KostaBodaLogoWhite.903ca42f.svg";